import { Component, OnInit, OnDestroy, HostListener } from "@angular/core";
import { CmsserviceService } from "../../common-cms-service/cmsservice.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { Title, Meta } from "@angular/platform-browser";
import { Router } from "@angular/router";
declare var $: any;

interface Slide {
  title: string;
  description: string;
  image: string;
  image_mobile?: string;
  button?: string;
  route?: string;
}

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.css"],
    standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>();

  // 🔹 Dynamic banners
  slides: Slide[] = [];
  currentIndex = 0;
  intervalId: any;

  // 🔹 Other data
  title = "Sehyog";
  siteSetting: any;
  images: any;
  currentSlide = 0;
  slideInterval: any;

   videos = [
    'https://www.youtube.com/embed/ro_eDXqzFt8',
    'https://www.youtube.com/embed/yEEVi_zJPho',
    'https://www.youtube.com/embed/9IwRPM5o_1o',
    'https://www.youtube.com/embed/ro_eDXqzFt8',
    'https://www.youtube.com/embed/yEEVi_zJPho'
  ];

  currentVSlide = 0;
  videosPerView = 3;
  totalSlides = 0;
  dots: number[] = [];

  // 🔹 Popup banners
  popups = [
    { img: "assets/images/csse-dc-popup.png", link: "/11plus-mocktest" },
    { img: "assets/images/popup1.png", link: "/rapid-course" },
    { img: "assets/images/popup2.png", link: "/creative-writing" },
    { img: "assets/images/popup3.png", link: "/11plus-mocktest" },
    { img: "assets/images/popup5.png", link: "/sat-test" },
  ];
  currentPopup: any = null;
  popupTimeout: any = null;

  // 🔹 Gallery section
  gal_images = [
    { src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769013030/2023_020_022_1_qguvff.jpg", title: "Award Ceremony" },
    { src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769012652/2023_020_034_ospqt0.jpg", title: "Award Ceremony" },
    { src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769013030/2023_020_040_1_kmobkn.jpg", title: "Award Ceremony" },
    { src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769013030/2023_020_086_1_pgnkwj.jpg", title: "Award Ceremony" },
    { src: "https://res.cloudinary.com/dlddixhyu/image/upload/v1769013030/2023_020_072_1_cpezhb.jpg", title: "Award Ceremony" },
  ];
  isSliding = false;
  currentImageIndex = 0;

  constructor(
    private cmsService: CmsserviceService,
    private router: Router,
    private titleService: Title,
    private meta: Meta
  ) {
    // SEO Meta
    this.meta.addTags([
      { name: "description", content: "This is 11plus Examination portal" },
      {
        name: "keywords",
        content:
          "gcse revision, gcse maths, gcse past papers, gcse science, gcse maths past papers, gcse revision websites, science gcse online, english gcse revision, mathematics gcse, science and maths tutor, online maths test, english language gcse revision, edexcel gcse maths, 11 plus exam papers, 11 plus tuition, 11 plus tutor, 11 plus tutors near me, 11 plus mock exams, 11 plus mock test, 11 plus papers, 11 plus test papers, eleven plus tuition, eleven plus mock exams, eleven plus papers, eleven plus tutors, 11 plus exam tuition, eleven plus exam papers, 11 plus exam tutors, 11 plus exam mock test, eleven plus test papers, eleven plus mock test, eleven plus verbal reasoning",
      },
    ]);
  }

  ngOnInit() {
    this.titleService.setTitle(this.title);

    // 🔹 Load banners dynamically
    this.loadHomeBanner();

    // 🔹 Load common site settings
    this.cmsService.commonSiteSettingSingleton().subscribe((res) => {
      this.siteSetting = res;
    });

    // 🔹 Load upcoming tests
    this.upcomingTest();

    // 🔹 Start auto-slide
    this.startAutoSlide();

    // 🔹 Schedule popup
    this.schedulePopup();

    // 🔹 Loader animation
    $(".loader-bg").fadeIn();

    this.calculateView();
  }

  /**Fetch banners dynamically from backend */
  loadHomeBanner() {
  this.cmsService
    .homeBanner()
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe({
      next: (res) => {
        if (res && Array.isArray(res.data)) {
          this.slides = res.data.map((banner: any) => {
            let description = banner.description || "";
            let route = "/"; // default

            // ✅ Check if description contains "link="
            const linkMatch = description.match(/link\s*=\s*(https?:\/\/[^\s"<]+)/i);
            if (linkMatch && linkMatch[1]) {
              route = linkMatch[1];
              // ✅ Remove that link text from description before showing it
              description = description.replace(linkMatch[0], "").trim();
            }

            return {
              title: banner.title || "",
              description,
              image: banner.image || "",
              button: "See More",
              route,
            } as Slide;
          });

          console.log("✅ Banners with extracted routes:", this.slides);
        } else {
          console.warn("No banner data found:", res);
        }
      },
      error: (err) => {
        console.error("Error fetching home banners:", err);
      },
    });
}

  /** Upcoming Session listing (existing logic) */
  upcomingTest() {
    this.cmsService
      .upcomingEventsRecord()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        this.images = res.data;
      });
  }

  /** Auto slide logic for banner */
  startAutoSlide() {
    this.intervalId = setInterval(() => {
      if (this.slides.length > 0) {
        this.nextSlide();
      }
    }, 5000);
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
  }

  previousSlide() {
    this.currentIndex =
      this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
  }

  onSlideButtonClick(index: number) {
    const slide = this.slides[index];
    if (slide && slide.route) {
      if (slide.route.startsWith("http")) {
        window.open(slide.route, "_blank");
      } else {
        this.router.navigate([slide.route]);
      }
    }
  }

  /** Gallery Methods */
  get currentImage() {
    return this.gal_images[this.currentImageIndex].src;
  }

  get currentTitle() {
    return this.gal_images[this.currentImageIndex].title;
  }

  changeImage(index: number) {
    if (index !== this.currentImageIndex) {
      this.isSliding = true;
      setTimeout(() => {
        this.currentImageIndex = index;
        this.isSliding = false;
      }, 300);
    }
  }

  /** WhatsApp Join */
  openWhatsApp() {
    window.open("https://chat.whatsapp.com/Epp2q0yma2r0YMa2VC0BPl", "_blank");
  }

  /** Popup Scheduling */
  schedulePopup() {
    this.popupTimeout = setTimeout(() => this.showRandomPopup(), 25000);
  }

  showRandomPopup() {
    const idx = Math.floor(Math.random() * this.popups.length);
    this.currentPopup = this.popups[idx];
  }

  closePopup() {
    this.currentPopup = null;
    this.schedulePopup();
  }

  bookSlot(): void {
    window.location.href =
      "https://www.sehyog.co.uk/11plus-help-club/category/workshop/5a96224a84937ec99f53ef8055c4b81d";
  }

  openQuestionBank(): void {
    window.location.href =
      "https://www.sehyog.co.uk/11plus-help-club/category/offers";
  }

  scrollToMain() {
    const mainElement = document.getElementById("sliderContainer");
    if (mainElement) mainElement.scrollIntoView({ behavior: "smooth" });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.popupTimeout) clearTimeout(this.popupTimeout);
  }



  get transformStyle(): string {
    const slideWidth = 100 / this.videosPerView;
    const offset = -this.currentVSlide * slideWidth * this.videosPerView;
    return `translateX(${offset}%)`;
  }

  slideVideo(direction: number) {
    this.currentVSlide += direction;
    this.currentVSlide = Math.max(0, Math.min(this.currentVSlide, this.totalSlides - 1));
  }

  goToSlide(index: number) {
    this.currentVSlide = index;
  }

  calculateView() {
    const width = window.innerWidth;
    this.videosPerView = width <= 640 ? 1 : width <= 992 ? 2 : 3;
    this.totalSlides = Math.ceil(this.videos.length / this.videosPerView);
    this.dots = Array(this.totalSlides).fill(0);
  }

  @HostListener('window:resize')
  onResize() {
    this.calculateView();
  }
}